// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-withdraw__text[data-v-7288d158] {\n  margin-bottom: 5px;\n  color: #f04;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
